export default function getCurrentDateTime() {
  return new Date();
}